// Shared US ZIP → lat/lng geocoder (free Zippopotam service, in-memory cached).
const ZIP_CACHE = new Map();

export async function geocodeZip(zip) {
    if (!/^\d{5}$/.test(zip || "")) return null;
    if (ZIP_CACHE.has(zip)) return ZIP_CACHE.get(zip);
    try {
        const res = await fetch(`https://api.zippopotam.us/us/${zip}`);
        if (!res.ok) { ZIP_CACHE.set(zip, null); return null; }
        const data = await res.json();
        const place = data.places?.[0];
        if (!place) { ZIP_CACHE.set(zip, null); return null; }
        const point = {
            lat: parseFloat(place.latitude),
            lng: parseFloat(place.longitude),
            city: place["place name"],
            state: place["state abbreviation"],
            label: `${place["place name"]}, ${place["state abbreviation"]}`,
        };
        ZIP_CACHE.set(zip, point);
        return point;
    } catch {
        return null;
    }
}
